import Global from './index.vue'

Global.install = function (Vue) {
  Vue.component(Global.name, Global)
}

export default Global